module.exports = __webpack_public_path__ + "media/onboarding/cpa_only_welcome-b28f9a27.png";